import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { exists } from '@nu-art/ts-common';
import './Component_TimeRangeInput.scss';
import { Dropdown_Timespans } from '../../../../../../../_enum.js';
import { inferMultiplier, TimespanToValue } from '@app/hcs-shared';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Component_TimeRangeInput extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        // Set the correct multiplier according to the value received from the editable item
        const value = state.editable.get(nextProps.index);
        const multiplier = inferMultiplier(value);
        state.multiplier = multiplier;
        // Make sure to initiate input value according to the multiplier
        state.inputValue = exists(value) ? String(value / (TimespanToValue[multiplier])) : undefined;
        return state;
    }
    updateValue = (value) => {
        let _value = value ?? this.state.inputValue ?? 0;
        if (!_value) {
            const newArray = [...this.state.editable.item];
            newArray[this.props.index] = undefined;
            this.state.editable.updateItem(newArray);
            //  FIXME: save me from this hackkkkk
            return this.state.editable.save();
        }
        _value = Number(_value);
        return this.state.editable.updateArrayAt(_value * TimespanToValue[this.state.multiplier], this.props.index);
    };
    render() {
        return _jsxs(LL_H_C, { className: _className('time-range-input', this.props.className), children: [_jsx(TS_Input, { placeholder: this.props.placeholder ?? 'Time', type: 'number', onBlur: (value) => {
                        this.setState({ inputValue: value }, () => this.updateValue(value));
                    }, value: this.state.inputValue }), _jsx(Dropdown_Timespans.selectable, { onSelected: value => this.setState({ multiplier: value }, () => this.updateValue(this.state.inputValue)), selected: this.state.multiplier })] });
    }
}
//# sourceMappingURL=Component_TimeRangeInput.js.map